export default [
  {
    name: 'register',
    path: '/register',
    meta: {
      authRequired: false,
    },
    //component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Register.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login.vue'),
  },
  {
    path: '/oauth-callback',
    name: 'OauthCallback',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/OauthCallback.vue'),
  },

  {
    path: '/unsubscribe-notification/:event',
    name: 'unsubscribeNotification',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/user/UnsubscribeMailNotification.vue'),
  },

  {
    path: '/messages',
    name: 'userMessages',
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackChunkName: "auth" */ '@/views/messages/Index.vue'),
  },

  /*{
    path: '/messages/:id',
    name: 'chat',
    component: () => import(/* webpackChunkName: "auth" */ //'@/views/messages/Chat.vue'),
  //},

  {
    path: '/account',
    name: 'account',
    props: route => ({ activeTab: route.query.tab }),
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackChunkName: "profile" */ '@/views/user/Update.vue'),
  },

  {
    path: '/courses',
    name: 'courses',
    props: true,
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackchunkname: "courses" */ '@/views/courses/Courses.vue'),
  },
  {
    path: '/courses/create',
    name: 'create-course',
    props: route => ({
      currentNetworkSlug: route.query.current_network_slug
    }),
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackChunkName: "courses" */ '@/views/courses/Create.vue'),
  },
  {
    path: '/courses/preview/:course_slug',
    props: true,
    name: 'preview-course',
    component: () => import(/* webpackchunkname: "courses" */ '@/views/courses/Preview.vue'),
  },
  {
    path: '/courses/:course_slug',
    props: true,
    name: 'view-course',
    component: () => import(/* webpackchunkname: "courses" */ '@/views/courses/Show.vue'),
  },
  {
    path: '/courses/:course_slug/edit',
    name: 'update-course',
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackChunkName: "courses" */ '@/views/courses/Update.vue'),
    props: route => ({
      ...route.params,
      activeTab: route.query.tab || 'home',
    }),
  },
  {
    path: '/courses/:course_slug/insights',
    name: 'course-insights',
    meta: {
      authRequired: true,
    },
    component: () => import(/* webpackChunkName: "courses" */ '@/components/forms/course/CourseAnalytics.vue'),
    props: route => ({
      courseSlug: route.params.course_slug
    }),
  },
  {
    path: '/events',
    name: 'events',
    props: true,
    component: () => import(/* webpackChunkName: "events" */ '@/views/Events.vue'),
  },
  {
    path: '/dashboard',
    name: 'admin',
    props: true,
    meta: {
      authRequired: true,
      roles: ['super-admin'],
    },
    component: () => import(/* webpackchunkname: "auth" */ '@/views/AdminDashboard.vue'),
  },
  {
    path: '/likes',
    name: 'likes',
    props: true,
    meta: {
      authRequired: true
    },
    component: () => import(/* webpackchunkname: "auth" */ '@/views/user/Likes.vue'),
  },
  {
    path: '/links',
    name: 'links',
    props: true,
    component: () => import(/* webpackChunkName: "links" */ '@/views/Links.vue'),
  },
];
